const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        credentials: 'include', // Important for sending HttpOnly cookies
    });

    if (response.status === 401) {
        console.error('Authentication expired or failed for:', url);
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.detail || errorData.message || 'API request failed');
    }

    return response.json();
};

// Pets API
export const fetchPets = async (familyId, filters = {}) => {
    const params = new URLSearchParams();
    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== null) {
            params.append(key, filters[key]);
        }
    }
    const queryString = params.toString();
    return fetchWithAuth(`/v1/families/${familyId}/pets${queryString ? `?${queryString}` : ''}`);
};

export const getPet = async (familyId, petId) => {
    return fetchWithAuth(`/v1/families/${familyId}/pets/${petId}`);
};

export const createPet = async (familyId, petData) => {
    return fetchWithAuth(`/v1/families/${familyId}/pets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(petData),
    });
};

export const updatePet = async (familyId, petId, petData) => {
    return fetchWithAuth(`/v1/families/${familyId}/pets/${petId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(petData),
    });
};

export const deletePet = async (familyId, petId) => {
    return fetchWithAuth(`/v1/families/${familyId}/pets/${petId}`, {
        method: 'DELETE',
    });
};

